import { Environment } from "@core/config/environment";

export const tooshareLevels = ["BEGINNER", "INTERMEDIATE", "ADVANCED"] as const;

export const jaangalLevels = [
	"CLASSE_6EME",
	"CLASSE_5EME",
	"CLASSE_4EME",
	"CLASSE_3EME",
	"CLASSE_2NDE",
	"CLASSE_1ERE",
	"CLASSE_TERMINALE",
] as const;

export const allContentLevels = Environment.APP_VARIANT === "jaangal" ? jaangalLevels : tooshareLevels;

export type ContentLevel = (typeof allContentLevels)[number];
